import { EStarRating } from '../../../JsonQuery';
import { starRatingLabels } from '../constants/starRatingLabels';

export function getStarRatingLabel(value: EStarRating[] | null): string | null {
  if (!value?.length) {
    return null;
  }

  const singleLabel = starRatingLabels[value[0]];

  return value.length > 1 ? `${singleLabel}, ...` : singleLabel;
}
